export default __webpack_public_path__ + "images/8a2c2e383aeccd5a051eae548f2a3afd.png";